import { spacings } from "@ui/Theme";
import { color } from "@ui";
import { css } from "@linaria/core";
import React from "react";
import cx from "classnames";

interface Props {
  label: string | number;
  value: string | number;
  weight?: "light";
}

const SelectionRow = (props: Props) => (
  <div
    className={cx(selectionRow, {
      [lightWeight]: props.weight === "light",
    })}
  >
    <span>{props.label}</span>
    <span>{props.value}</span>
  </div>
);

const selectionRow = css`
  display: flex;
  margin-bottom: ${spacings.xs};
  justify-content: space-between;
  font-size: 14px;
  color: ${color.carbon900};

  span:last-child {
    font-weight: 600;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
const lightWeight = css`
  font-size: ${spacings.s};
  color: ${color.carbon800};

  span:last-child {
    font-weight: 400;
  }
`;

export default SelectionRow;
